module.exports = __webpack_public_path__ + "img/icon_tips4.d006f192.png";